import React, { useContext, useState, useEffect } from 'react';
import Fade from 'react-reveal/Fade';
import { Container, Row, Col } from 'react-bootstrap';
import Title from '../Title/Title';
import AboutImg from '../Image/AboutImg';
import PortfolioContext from '../../context/context';

const About = () => {
  const { about } = useContext(PortfolioContext);
  const { img, paragraphOne, paragraphTwo, paragraphThree, resume } = about;

  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  return (
    <section id="about">
      <Container>
        <Title title="Know More" />
        <Row className="about-wrapper">
          <Col md={6} sm={12}>
            <Fade bottom duration={1000} delay={600} distance="30px">
              <div className="about-wrapper__image">
                <AboutImg alt="profile picture" filename={img} />
              </div>
            </Fade>
          </Col>
          <Col md={6} sm={12}>
            <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={1000} distance="30px">
              <div className="about-wrapper__info">
                <p className="about-wrapper__info-text" style={{ color: "#264653" }}>
                  Bio
                </p>
                <p className="about-wrapper__info-text">
                  {paragraphOne
                  }
                </p>
                <p className="about-wrapper__info-text" style={{ color: "#264653" }}>
                  Awards and Recognition
                </p>
                <p className="about-wrapper__info-text">
                  {paragraphTwo}
                </p>
                <p className="about-wrapper__info-text">
                  Participated in several National Painting Competition conducted by
                  Central Govt of India
                </p>
                <p className="about-wrapper__info-text" style={{ color: "#264653" }}>
                  Skills</p>
                <p className="about-wrapper__info-text" >
                  <li>Programming - C , C++ , Java</li>
                  <li>Web Development- HTML,CSS, JavaScript, Basics of PHP , React</li>
                  <li>Backend- Node.js , Express.js
                  </li>
                  <li>Database-Mysql, MongoDB , Firebase</li>
                  <li>Application development – Android Development</li>
                  <li>Tools – Git, Npm , Postman</li>
                  <li>Design – UI/UX</li>
                </p>

                {resume && (
                  <span className="d-flex mt-3">
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cta-btn cta-btn--resume"
                      href={resume}
                    >
                      Resume
                    </a>
                  </span>
                )}
              </div>
            </Fade>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
